import _ from "lodash";
import {
  CURRICULUM_TYPE_UBD,
  CURRICULUM_TYPE_DP,
} from "Constants/stringConstants";
import ACLStore from "lib/aclStore";
import { openLinkInNewTab } from "modules/Services";
import { colors } from "@toddle-edu/ds-theme";
import update from "immutability-helper";
import { getSelectedCurriculumId, getUserType } from "modules/CommonSelectors";
import { BAR_COLOR_BY_TYPE } from "AppComponents/StudentProgressSummary/modules/StudentProgressSummaryConstants";
import { checkVisualiseGradebookChangesEnabled } from "AppComponents/StudentProgressSummary/modules/StudentProgressSummaryUtils";
import ACLStorage from "lib/aclService";
import { PROGRESS_REPORTS_PROGRAMME_LEVEL_VIEW_PERMISSION } from "Constants/permissionConstants";
import { getIsLearningCoursesEnabled } from "LearningCourses/modules/Utils";

export const NAME = "studentProgressSummary";

//to update the reportId in MYP subject summary screen
export const UPDATE_MYP_SUBJECT_SUMMARY_FILTERS =
  "UPDATE_MYP_SUBJECT_SUMMARY_FILTERS" + " " + NAME;

//to update the dropdown filters in MYP Criteria screen
export const UPDATE_MYP_CRITERIA_FILTERS =
  "UPDATE_MYP_CRITERIA_FILTERS" + " " + NAME;

//reset filters in all the screens once we exit the Student Progress Summary
export const RESET_STUDENT_PROGRESS_SUMMARY_FILTERS =
  "RESET_STUDENT_PROGRESS_SUMMARY_FILTERS" + " " + NAME;

//to update the dropdown filters in Assessment screen
export const UPDATE_ASSESSMENT_FILTERS =
  "UPDATE_ASSESSMENT_FILTERS" + " " + NAME;

export const UPDATE_ELEMENT_ROOT_ID = "UPDATE_ELEMENT_ROOT_ID" + " " + NAME;

// to reset filters used on all assessments screen
export const RESET_ALL_ASSESSMENTS_FILTERS = `RESET_ALL_ASSESSMENTS_FILTERS ${NAME}`;

export const resetAllAssessmentsFilters = () => {
  return {
    type: RESET_ALL_ASSESSMENTS_FILTERS,
  };
};

export const updateMYPSubjectSummaryFilters = data => {
  return {
    type: UPDATE_MYP_SUBJECT_SUMMARY_FILTERS,
    data,
  };
};

export const updateMYPCriteriaFilters = data => {
  return {
    type: UPDATE_MYP_CRITERIA_FILTERS,
    data,
  };
};

export const resetStudentProgressSummaryFilters = data => {
  return {
    type: RESET_STUDENT_PROGRESS_SUMMARY_FILTERS,
    data,
  };
};

export const updateAssessmentFilters = data => {
  return {
    type: UPDATE_ASSESSMENT_FILTERS,
    data,
  };
};

const initialState = {
  mypSubjectSummaryFilters: {
    selectedReportId: "",
  },
  mypCriteriaFilters: {
    currentSubjectId: "",
    currentObjectiveId: "",
  },
  elementRootId: {
    lp: null,
    atls: null,
    benchmarks: null,
    DP_OBJECTIVES: null,
  },
  assessmentFilters: {
    currentSubjectId: "",
    currentObjectiveId: "",
    searchText: "",
    selectedSubjects: [],
    selectedClasses: [],
    selectedAssessmentTools: [],
    selectedCriterias: [],
    selectedAssessmentTypes: [],
    selectedTermIds: [],
    selectedTermIdsList: [],
    selectedAcademicYearId: "",
    selectedCategories: [],
  },
};

const REDUCER_HANDLERS = {
  [RESET_ALL_ASSESSMENTS_FILTERS]: state => {
    return {
      ...state,
      assessmentFilters: {
        ..._.get(state, "assessmentFilters", {}),
        searchText: "",
        selectedClasses: [],
        selectedAssessmentTypes: [],
        selectedAssessmentTools: [],
        selectedCriterias: [],
      },
    };
  },
  [UPDATE_MYP_SUBJECT_SUMMARY_FILTERS]: (state, action) => {
    const { key, value } = action.data;
    return update(state, {
      mypSubjectSummaryFilters: { [key]: { $set: value } },
    });
  },
  [UPDATE_MYP_CRITERIA_FILTERS]: (state, action) => {
    const { key, value } = action.data;
    return update(state, {
      mypCriteriaFilters: { [key]: { $set: value } },
    });
  },
  [UPDATE_ASSESSMENT_FILTERS]: (state, action) => {
    const { key, value } = action.data;
    return update(state, {
      assessmentFilters: { [key]: { $set: value } },
    });
  },
  [UPDATE_ELEMENT_ROOT_ID]: (state, action) => {
    const params = action.data;
    Object.keys(params).map((key, index) => {
      state = update(state, {
        elementRootId: { [key]: { $set: params[key] } },
      });
    });
    return state;
  },

  [RESET_STUDENT_PROGRESS_SUMMARY_FILTERS]: (state, action) => {
    const assessmentFiltersToExclude = _.get(
      action,
      "data.assessmentFiltersToExclude",
      []
    );
    const params = initialState.assessmentFilters;

    Object.keys(params).map(key => {
      const shouldExclude = _.includes(assessmentFiltersToExclude, key);

      if (!shouldExclude) {
        state = update(state, {
          assessmentFilters: {
            [key]: { $set: params[key] },
          },
        });
      }
    });

    return update(state, {
      mypSubjectSummaryFilters: { $set: initialState.mypSubjectSummaryFilters },
      mypCriteriaFilters: { $set: initialState.mypCriteriaFilters },
    });
  },
};

export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}

export const getCriteriaList = ({ isIL }) => {
  return isIL ? ["A", "B", "C"] : ["A", "B", "C", "D"];
};

export const IB_GRADE_COLORS = [
  colors.violet500,
  colors.pink300,
  colors.blue600,
  colors.teal400,
  colors.purple400,
  colors.yellow500,
  colors.orange600,
  colors.red52,
  colors.blue400,
  colors.yellow300,
  colors.green600,
  colors.violet700,
  colors.blue700,
  colors.teal600,
  colors.pink600,
  colors.red66,
  colors.orange400,
  colors.violet300,
  colors.violet600,
  colors.purple200,
  colors.purple600,
  colors.purple800,
  colors.pink800,
  colors.orange800,
  colors.yellow700,
  colors.pink100,
  colors.blue300,
  colors.teal800,
  colors.green400,
  colors.green800,
  colors.orange300,
  colors.yellow400,
  colors.neutral300,
  colors.neutral500,
];

export const nodes = [
  {
    id: "STUDENT_PROFILE",
    label: "studentProgressSummary:student_profile",
    route: "student-profile",
  },
  {
    id: "PS",
    label: "studentProgressSummary:progress_summary_capitalize",
    children: ["SUBJECT_SUMMARY", "MYP_CRITERIA"],
  },
  {
    id: "SUBJECT_SUMMARY",
    label: "studentProgressSummary:progress_report_overview",
    parent: "PS",
    route: "subject-summary",
  },
  {
    id: "MYP_CRITERIA",
    label: "studentProgressSummary:myp_criteria",
    parent: "PS",
    route: "myp-criteria",
  },
  {
    id: "ATL",
    label: "common:atls_label",
    parent: "PS",
    route: "atls",
    idForCurriculum: {
      [CURRICULUM_TYPE_DP]: "atls",
      [CURRICULUM_TYPE_UBD]: "atls",
    },
  },
  {
    id: "DP_OBJECTIVES",
    label: "common:DP_OBJECTIVES_label",
    parent: "PS",
    route: "objectives",
  },
  {
    id: "benchmarks",
    label: "common:content_standards",
    parent: "PS",
    route: "benchmarks",
  },
  {
    id: "lp",
    label: "common:lp_label",
    parent: "PS",
    route: "lp",
  },
  {
    id: "ASSESSMENT",
    label: "common:assessment_label_plural",
    route: "assessment",
  },
  {
    id: "SERVICE_LEARNING_OUTCOMES",
    label: "studentProgressSummary:service_learning_outcomes",
    route: "service-learning-outcomes",
  },
  {
    id: "ATTENDANCE",
    label: "teacherHomePage:attendance",
    route: "attendance",
  },
];

export const getFirstSectionId = ({ rootNodes }) => {
  for (const nodeId of rootNodes) {
    const node = _.find(nodes, { id: nodeId });
    const hasChildren = !_.isEmpty(node.children);
    const isPermission = node.perm ? ACLStore.can(node.perm) : true;
    if (isPermission) {
      if (!hasChildren) {
        return node.id;
      } else {
        return getFirstSectionId({ rootNodes: node.children });
      }
    }
  }
};

export const getFinalAndLocalGrades = ({
  finalGradeCriteriaSet,
  ibPYPElementRatings,
  subjectId,
}) => {
  const finalGradeSetValues = _.get(
    finalGradeCriteriaSet,
    "academicCriteriaValues",
    []
  );
  /* find the respective final grade object from organizationFinalGrades where our total grade is
     in the range defined by IB. (boundaryGuidelines) */
  let finalGradeObject = {};

  // instead use rating that was published on final grade
  const finalGradeRating = _.find(ibPYPElementRatings, rating => {
    return (
      _.get(rating, "academicCriteriaSet.id") ==
        _.get(finalGradeCriteriaSet, "id") &&
      _.get(rating, "ibPYPElementId") == subjectId
    );
  });
  const valueId = _.get(finalGradeRating, "academicCriteriaValue.id");
  finalGradeObject = _.find(finalGradeSetValues, {
    id: valueId,
  });

  const finalGrade = parseInt(_.get(finalGradeObject, "label", null));
  //calculate local grade
  /* find the corresponding local grade for the grade where the grade is publishedReportGradeId */
  const localGradeObject = _.find(ibPYPElementRatings, rating => {
    return _.get(rating, "academicCriteriaSet.criteriaType") == "LOCAL_GRADE";
  });
  const localGrade = _.get(
    localGradeObject,
    "academicCriteriaValue.abbreviation",
    null
  );
  return { finalGrade, localGrade };
};

const getFinalScore = ({ ibPYPElementRatings }) => {
  /* Calculate Final Score */
  const finalScoreRating = _.find(ibPYPElementRatings, rating => {
    return _.get(rating, "academicCriteriaSet.criteriaType") == "FINAL_SCORE";
  });
  const finalScore = _.get(finalScoreRating, "value");
  return finalScore;
};

/* This function calculates the ratings on IB_DEFINED Criteria (Achievement)*/
const getIbCriteriaRatings = ({ objectives, ibPYPElementRatings }) => {
  const ibCriteriaRatings = {
    A: undefined,
    B: undefined,
    C: undefined,
    D: undefined,
  };
  //for each item in objectives array, find its rating in ibPYPElementRatings array.
  for (const objective of objectives) {
    const ibPYPElementRating = _.find(
      ibPYPElementRatings,
      ibPYPElementRating =>
        ibPYPElementRating.ibPYPElementId == objective.id &&
        ibPYPElementRating.academicCriteriaSet.criteriaType == "IB_DEFINED" &&
        ibPYPElementRating.ibPYPElementType == "MYP_OBJECTIVES"
    );
    if (!_.isEmpty(ibPYPElementRating)) {
      const criteriaRating = _.get(
        ibPYPElementRating,
        "academicCriteriaValue.abbreviation",
        undefined
      );
      //map them with A B C D based on the objectiveLabel
      const objectiveLabel = _.get(objective, "label", "");

      for (const ibCriteria of ["A", "B", "C", "D"]) {
        const regex = new RegExp(`/*objective ${ibCriteria}/*`, "i");
        if (regex.test(objectiveLabel)) {
          ibCriteriaRatings[`${ibCriteria}`] = parseInt(criteriaRating);
        }
      }
    }
  }
  return ibCriteriaRatings;
};

/* collect all the required data and store it as array of objects.
     each object in the array contains data related to that row like
     subject
     ibCriteriaRatings- contains ratings on IB Defined criteria A B C D (Achievement)
     finalGrade
     localGrade
     customCriteriaRatings - contains ratings on cutom defined criteria like Efficiency, Effort etc.
                             It is an array of objects and each object contains id,label and rating of custom criteria.
  */
export const getMYPSubjectSummaryData = ({
  publishedReportGradeId,
  subjectSummary,
  templateCustomCriteriaSets,
  finalGradeCriteriaSet,
}) => {
  const subjectSummaryData = _.map(subjectSummary, item => {
    const { subject, objectives, ibPYPElementRatings } = item;
    //1) get ib criteria a b c d values (achievement)
    const ibCriteriaRatings = getIbCriteriaRatings({
      objectives,
      ibPYPElementRatings,
    });
    //2) calculate total of criteria a b c d to calculate the final grade
    const totalIbCriteriaRating = _.reduce(
      _.values(ibCriteriaRatings),
      (sum, n) => sum + n,
      0
    );

    //3) calculate final grade and local grade
    const { finalGrade, localGrade } = getFinalAndLocalGrades({
      totalIbCriteriaRating,
      reportGradeId: publishedReportGradeId,
      finalGradeCriteriaSet,
      ibPYPElementRatings,
      subjectId: _.get(subject, "id"),
    });

    // 4) calculate final score
    const finalScore = getFinalScore({ ibPYPElementRatings });

    //5) calculate ratings on custom criteria
    //check if it is subject or interdisciplinary learning
    const isIL = _.isNull(subject);
    const customCriteriaRatings = _.map(
      templateCustomCriteriaSets,
      customCriteriaSet => {
        const ibPYPElementRating = _.find(ibPYPElementRatings, item => {
          if (isIL) {
            return (
              _.isNull(item.ibPYPElementId) &&
              item.ibPYPElementType == "MYP_OBJECTIVES" &&
              item.academicCriteriaSet.id == customCriteriaSet.id
            );
          } else {
            return (
              item.ibPYPElementId == subject.id &&
              item.ibPYPElementType == "MYP_SUBJECT" &&
              item.academicCriteriaSet.id == customCriteriaSet.id
            );
          }
        });
        const rating = _.get(
          ibPYPElementRating,
          "academicCriteriaValue.abbreviation",
          null
        );
        return { ...customCriteriaSet, rating };
      }
    );
    return {
      subject,
      ibCriteriaRatings,
      finalGrade,
      localGrade,
      customCriteriaRatings,
      finalScore,
    };
  });

  return subjectSummaryData;
};

/*
  collect all the required data for MYP Criteria screen and store it as array of objects.
  Each object contains
    id
    label - (example Objective A: Creating)
    associatedRatings
      -it contains rating history data
      -it is array of objects
      -each object contains
        id
        rating (rating abbreviation)
        fill (color)
        label (name of the progress report or assessment)
        parentType (enum)
        parent (object)

   The ratings come from either progress report or assessments as of now.
*/

export const getCriteriaWithAssociatedRatings = ({ queryData }) => {
  const criteriaNodes = _.get(queryData, "nodes", []);
  const criteriaWithAssociatedRatingsData = _.map(criteriaNodes, node => {
    const { id, label, associatedData = {} } = node;
    const associatedRatingsData = _.get(
      associatedData,
      "associatedRatings.edges",
      []
    );

    const filteredAssociatedRatings = _.filter(associatedRatingsData, item => {
      const node = _.get(item, "node", {});
      const criteriaType = _.get(node, "academicCriteriaSet.criteriaType", "");
      const parentType = _.get(node, "parentType", "");
      const contentType = _.get(node, "parent.assignment.contentType", "");

      return (
        criteriaType == "IB_DEFINED" &&
        (parentType == "STUDENT_PROGRESS_REPORT" ||
          (parentType == "STUDENT_ASSIGNMENT" && contentType == "ASSESSMENT"))
      );
    });

    const associatedRatings = _.map(
      filteredAssociatedRatings,
      (item, index) => {
        const node = _.get(item, "node", {});
        const parentType = _.get(node, "parentType", "");
        const publishedAt = _.get(node, "publishedAt", "");
        const parent = _.get(node, "parent", {});
        const rating = _.get(node, "academicCriteriaValue.abbreviation", 0);
        let label = "";
        let elementType = "";
        let imageUrl = "";
        let termLabel = "";
        switch (parentType) {
          case "STUDENT_PROGRESS_REPORT":
            label = _.get(parent, "courseProgressReportTask.title", "");
            elementType = "report";
            termLabel = _.get(
              parent,
              "courseProgressReportTask.progressReportTaskGroup.academicTerm.label",
              ""
            );
            break;
          case "STUDENT_ASSIGNMENT":
            label = _.get(parent, "assignment.content.title.value", "");
            elementType = _.get(
              parent,
              "assignment.content.assessmentType.value",
              ""
            );
            imageUrl = _.get(parent, "assignment.content.image.value");
            termLabel = _.get(
              parent,
              "assignment.content.academicTerm.label",
              ""
            );
            break;
        }

        const isVisualiseGradebookChangesEnabled = checkVisualiseGradebookChangesEnabled();

        let color;
        if (isVisualiseGradebookChangesEnabled) {
          const assessmentType = _.get(
            parent,
            "assignment.content.assessmentType.value"
          );

          color = BAR_COLOR_BY_TYPE[assessmentType || parentType];
        } else {
          color = IB_GRADE_COLORS[index % _.size(IB_GRADE_COLORS)];
        }

        return {
          id: node.id,
          rating,
          fill: color,
          label,
          parentType,
          parent,
          publishedAt,
          elementType,
          imageUrl,
          index,
          termLabel,
        };
      }
    );

    return {
      id,
      label,
      associatedRatings,
    };
  });

  return criteriaWithAssociatedRatingsData;
};

/*
This function redirects to that particular page.
Used in
  - Subject Summary screen
  - MYP Criteria screen
  - Assessments screen
*/
export const onItemClickRedirect = ({ parentType, parent }) => {
  return (dispatch, getState) => {
    const state = getState();
    const userType = getUserType(state);
    const curriculumId = getSelectedCurriculumId(state);
    switch (parentType) {
      case "STUDENT_PROGRESS_REPORT": {
        const reportId = _.get(parent, "id", "");
        const url = `/platform/links/progress-report/${reportId}`;
        dispatch(openLinkInNewTab({ url }));
        break;
      }
      case "STUDENT_ASSIGNMENT": {
        const assignmentId = _.get(parent, "assignment.id", "");
        const courseId = _.get(parent, "assignment.course.id", "");
        let url = `/platform/links/classroom-details/${assignmentId}`;
        const isLearningCourseEnabled = getIsLearningCoursesEnabled();

        if (isLearningCourseEnabled) {
          if (userType === "staff") {
            url = `/platform/${curriculumId}/links/classroom-details/${assignmentId}/allsubmissions`;
          } else {
            url = `/platform/${curriculumId}/links/classroom-details/${assignmentId}`;
          }
        } else if (courseId) {
          if (userType === "staff") {
            url = `/platform/${curriculumId}/courses/${courseId}/links/classroom-details/${assignmentId}/allsubmissions`;
          } else {
            url = `/platform/${curriculumId}/courses/${courseId}/links/classroom-details/${assignmentId}`;
          }
        }
        dispatch(openLinkInNewTab({ url }));
        break;
      }
    }
  };
};

/* this funciton returns either objective id which has rating
   or the first objective's id in case there aren't any objectives with rating.
   Used in
    - MYP Criteria screen
    - Assessments screen
*/
export const getDefaultObjectiveId = ({ subject }) => {
  const firstObjectiveIdWithRatings = _.get(
    subject,
    "objectiveYearsWithRatings[0].id",
    ""
  );
  const firstObjectiveId = _.get(subject, "objectives[0].id", "");
  const objectiveId = firstObjectiveIdWithRatings
    ? firstObjectiveIdWithRatings
    : firstObjectiveId;
  return objectiveId;
};

/*this funciton converts the query data into array of objects where
  each object contains data related to subject,objectives and objectiveYearsWithRatings
     Used in
    - MYP Criteria screen
    - Assessments screen
*/
const getSubjectObjectivesData = ({ subjects }) => {
  const subjectObjectivesData = _.map(subjects, subject => {
    const associatedChildPlannerElementNodes = _.get(
      subject,
      "associatedChildPlannerElementNodes",
      []
    );
    const objectives = _.map(associatedChildPlannerElementNodes, item => {
      return {
        id: item.id,
        value: item.id,
        label: _.replace(item.label, /objectives/gi, ""),
      };
    });
    return {
      id: subject.id,
      value: subject.id,
      label: subject.name,
      isArchived: _.get(subject, "isArchived", false),
      objectiveYearsWithRatings: subject.objectiveYearsWithRatings,
      objectives,
      type: _.get(subject, "type"),
    };
  });

  //append data related to IL
  subjectObjectivesData.push({
    id: "IL",
    value: "IL",
    label: "Interdisciplinary Learning",
    objectives: [],
    objectiveYearsWithRatings: [],
  });
  return subjectObjectivesData;
};

export const getSubjectObjectivesDataMemoize = _.memoize(
  params => getSubjectObjectivesData(params),
  params => JSON.stringify(params)
);

const getStudentSLOInsightsData = ({ sloData, insightsNodesList }) => {
  const insightsNodesListObjMap = _.keyBy(insightsNodesList, "node.id");
  const insightsData = _.map(sloData, item => {
    //1) get the title of service learning outcome
    const id = _.get(item, "id", "");
    const title = _.get(item, "label", "");
    //find the corresponding node of insights data
    const insightsNode = insightsNodesListObjMap[id];

    //2) get the no.of times covered
    const addressedInProjects = _.get(insightsNode, "addressedInProjects", []);

    const coveredCount = _.size(addressedInProjects);
    //3) get the no.of evidences
    const evidenceInPosts = _.get(insightsNode, "evidenceInPosts", []);
    const evidenceCount = _.size(evidenceInPosts);
    const postIds = _.map(evidenceInPosts, post => _.get(post, "id", ""));
    return {
      id,
      title,
      coveredCount,
      evidenceCount,
      postIds,
      coveredInProjects: addressedInProjects,
    };
  });
  return insightsData;
};

export const getStudentSLOInsightsDataMemoize = _.memoize(
  params => getStudentSLOInsightsData(params),
  params => JSON.stringify(params)
);

export const isReportVisible = () => {
  return ACLStorage.getModuleSettingsValue(
    PROGRESS_REPORTS_PROGRAMME_LEVEL_VIEW_PERMISSION
  );
};
